export default {
    namespaced: true,
    state: {
        token: null
    },
    getters: {
        authenticated (state) {
            return state.token
        },
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
        }
    },
    actions: {
        async attempt( { commit }, token ) {
            if(token) {
                commit('SET_TOKEN', token)
            }
        },
        signOut({ commit }) {
            commit('SET_TOKEN', null)
        }
    }
}